export default "__VITE_ASSET__Bqguo3_k__"